// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__tCcEH","innerWrapper":"Footer_innerWrapper__Sl1zW","copyrigth":"Footer_copyrigth__MlHH9","logo":"Footer_logo__bnxmS","wrapper":"Footer_wrapper__W9sAe"};